// _public_pc/components/NavbarPC.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useNavbar } from '../_shared/hooks/useNavbar';
import { FaWhatsapp, FaUsers, FaClock } from 'react-icons/fa';
import { getContrastColor, isLightColor } from '../_shared/utils/colorUtils';
import './NavbarPC.css';

const NavbarPC = ({ 
  slug, 
  colors, 
  onInscribeteClick,
  onCompetitorsClick,
  onTimesClick,
  refreshCompetitors,
  showFormulario = false 
}) => {
  const { telefono, loading } = useNavbar(slug);

  const whatsappUrl = telefono ? `https://wa.me/${telefono}` : '#';

  const handleCompetitorsClick = async () => {
    
    
    if (refreshCompetitors) {
      
      await refreshCompetitors();
      
    } else {
      console.warn('⚠️ refreshCompetitors no está disponible');
    }
    
    if (onCompetitorsClick) {
      
      onCompetitorsClick();
    }
  };
  

  // Colores del organizador
  const primaryColor = colors?.primaryColor || '#9370DB';
  const secondaryColor = colors?.secondaryColor || '#0b0b1a';
  
  // Texto con contraste automático
  const textColor = colors?.textColor || getContrastColor(primaryColor);
  
  // Determinar si el color primario es claro
  const isPrimaryLight = isLightColor(primaryColor);
  
  // Para el degradado del navbar
  const navbarGradient = `linear-gradient(90deg, ${primaryColor} 33%, ${secondaryColor} 67%)`;
  
  // Color del texto del WhatsApp (siempre blanco con fondo oscuro)
  const whatsappTextColor = isLightColor(secondaryColor) ? '#1a1a2e' : '#ffffff';

  return (
    <nav 
      className="navbar-pc"
      style={{ 
        background: navbarGradient,
        color: textColor
      }}
    >
      <div className="navbar-pc-left">
        <Link to="/" className="navbar-pc-logo-link">
          <img 
            src="/images/logox.png" 
            alt="InnovateSport Logo" 
            className="navbar-pc-logo" 
          />
        </Link>
        <span className="navbar-pc-title" style={{ color: textColor }}>
          {slug || 'Cargando...'}
        </span>
      </div>

      <div className="navbar-pc-right">
        {/* ✅ Botón Inscritos */}
        <button
          className="navbar-pc-btn navbar-pc-competitors-btn"
          onClick={handleCompetitorsClick}
          style={{ 
            color: textColor,
            borderColor: isLightColor(secondaryColor) ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.15)'
          }}
        >
          <FaUsers className="navbar-pc-btn-icon" />
          <span className="navbar-pc-btn-label">Inscritos</span>
        </button>

        {/* ✅ Botón Tiempos */}
        <button
          className="navbar-pc-btn navbar-pc-times-btn"
          onClick={onTimesClick}
          style={{ 
            color: textColor,
            borderColor: isLightColor(secondaryColor) ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.15)'
          }}
        >
          <FaClock className="navbar-pc-btn-icon" />
          <span className="navbar-pc-btn-label">Tiempos</span>
        </button>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="navbar-pc-whatsapp"
          style={{ 
            color: whatsappTextColor,
            background: isLightColor(secondaryColor) ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.05)'
          }}
        >
          <FaWhatsapp className="navbar-pc-whatsapp-icon" />
          <span>{loading ? 'Cargando...' : 'CONTACTO'}</span>
        </a>

        <button 
          className="navbar-pc-inscribete" 
          onClick={onInscribeteClick}
        >
          INSCRÍBETE
        </button>
      </div>
    </nav>
  );
};

export default NavbarPC;